import { t } from '@lingui/core/macro';
import { Box, Skeleton, Typography } from '@pocketlaw/tetris';
import { getCurrentMarketTemplateLocales } from 'shared/domains/markets/config';
import { useComposerData } from '../../../ComposerDataProvider';
import { FilterChip } from '../FilterChip';
export function Languages() {
    const locales = getCurrentMarketTemplateLocales();
    const { selectedLanguages, addSelectedLanguage, removeSelectedLanguage, loading } = useComposerData();
    const title = t({
        message: 'Languages',
        comment: 'Select template dialog - Languages label',
    });
    return (<Box flexDirection="column" gap="md">
      <Skeleton loading={loading}>
        <Typography $fontSize="small" $appearance="100" $fontWeight="semibold">
          {title}
        </Typography>
      </Skeleton>
      <Box gap="md" flexDirection="column">
        {locales.map(({ getName, languageCode }) => (<FilterChip key={languageCode} selected={selectedLanguages.includes(languageCode)} onAdd={() => addSelectedLanguage(languageCode)} onRemove={() => removeSelectedLanguage(languageCode)} label={getName()}/>))}
      </Box>
    </Box>);
}
